import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["select", "form"];

  navigate(event) {
    const url = event.target.value;
    if (!url) return;

    this.selectTarget.disabled = true;
    this.formTarget.action = url;
    this.formTarget.requestSubmit();
  }

  async restore(event) {
    const state =
      typeof event.state === "string" ? JSON.parse(event.state) : event.state;
    const url = state?.versionUrl || `${location.pathname}?restore=1`;
    await get(url, { responseKind: "turbo-stream" });
  }

  enableSelect() {
    this.selectTarget.disabled = false;
  }
}
